// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AuthUrl } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGoogleAuthUrl(): (state: string) => Promise<AuthUrl> {
  const getAPI = useGetApi();
  return useCallback(
    async (state) => (await getAPI()).externesysteme.googleAuthUrl({ state }),
    [getAPI]
  );
}
